import script from "./MatchTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchTooltip.vue?vue&type=script&setup=true&lang=js"

import "./MatchTooltip.vue?vue&type=style&index=0&id=4a03f048&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a03f048"]])

export default __exports__